export default {
  container: 'w-[272px] max-h-[288px] flex flex-col items-center gap-[34px] rounded-2xl bg-color-white px-[34px] pt-[24px] pb-[34px] shadow-[0_20px_40px_rgba(0,0,0,0.05)]',
  image: 'w-[102px] h-[102px]',
  text: 'font-interSemibold text-[20px] leading-[24px] text-color-blue-primary text-center sm:text-[24px] sm:leading-[29px]',
};
